import * as API from './../base/api_service';
import * as serviceCallConfig from './../config/api_urls';

export var TICKETS_LIST = 'TICKETS_LIST';

export var TICKETS_CONVERSTION = 'TICKETS_CONVERSTION';

export var TICKETS_CONVERSTION_REPLY = 'TICKETS_CONVERSTION_REPLY';

export var TICKETS_STAUTS = 'TICKETS_STAUTS';

export var CHANGE_STATUS_TO_NULL = 'CHANGE_STATUS_TO_NULL';
export var EXPORT_DATA = 'EXPORT_DATA'
export var EXPORT_DATA_RESPONSE = 'EXPORT_DATA_RESPONSE';

export var getTickets = (data) => {

    return (dispatch, getState) => {
         API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.TICKETS_List),//endPoint
            data,//payLoad
            serviceCallConfig.TICKETS_List,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var exportData = () => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.EXPORT_DATA),//endPoint
            '',//payLoad
            serviceCallConfig.EXPORT_DATA,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );        
    };
};

export var exportDataResponse = (data) => {

    return ({
        type: EXPORT_DATA_RESPONSE,
        data: data
    })
};

export var getTicketsConverstion = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.TICKETS_CONVERSTION),//endPoint
            '',//payLoad
            serviceCallConfig.TICKETS_CONVERSTION,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );
        
    };
};

export var getTicketsConverstionReply = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
           serviceCallConfig.API_POST,//reqType
           dispatch,//dispatch
           serviceCallConfig.get(serviceCallConfig.TICKETS_CONVERSTION_REPLY),//endPoint
           data,//payLoad
           serviceCallConfig.TICKETS_CONVERSTION_REPLY,//requestFrom
           false,//isURLEncoded
           getState().User.loginData.data.accessToken, //authKey
           '',//api_key
           '',//getParams
           false, //multipart
           getState().User.loginData.data.uniqueKey //uniqueKey
       );
   };
};

export var getStatus = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_PUT,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.TICKETS_STAUTS),//endPoint
            '',//payLoad
            serviceCallConfig.TICKETS_STAUTS,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );
        
    };
}; 

export var ticketsData = (data) => {    
    return ({
        type: TICKETS_LIST,
        data: data
    });
};

export var ticketsConverstionData = (data) => {
    return ({
        type: TICKETS_CONVERSTION,
        data: data
    })
};

export var ticketsConverstionReplyData = (data) => {
    return ({
        type: TICKETS_CONVERSTION_REPLY,
        data: data
    })
};


export var statusData = (data) => {
    return ({
        type: TICKETS_STAUTS,
        data: data
    })
}

export var changeStatusToNull = () => {
    return({
        type: CHANGE_STATUS_TO_NULL
    })
}


/** WEBPACK FOOTER **
 ** ./src/actions/ticket_actions.js
 **/